import { createContext } from 'react';
import type { SlideoutDrawerContextValue } from './types';

export const SlideoutDrawerContext = createContext<SlideoutDrawerContextValue | null>(null);
